(() => {
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

  document.documentElement.classList.add('cerise-js');

  const updateHeaderState = () => {
    document.body?.classList.toggle('cerise-scrolled', window.scrollY > 24);
  };

  const revealElements = (root = document) => {
    const elements = [...root.querySelectorAll('[data-cerise-reveal]:not(.is-visible)')];

    if (!elements.length) return;

    if (reducedMotion.matches || !('IntersectionObserver' in window)) {
      elements.forEach((element) => element.classList.add('is-visible'));
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );

    elements.forEach((element) => observer.observe(element));
  };

  const openCookiePreferences = (event) => {
    const trigger = event.target.closest('[data-cerise-cookie-settings]');
    if (!trigger) return;

    const preferenceApi = window.privacyBanner;

    if (typeof preferenceApi?.showPreferences !== 'function') return;

    event.preventDefault();

    Promise.resolve(preferenceApi.showPreferences()).catch(() => {
      window.location.assign(trigger.href);
    });
  };

  updateHeaderState();
  revealElements();

  window.addEventListener('scroll', updateHeaderState, { passive: true });
  document.addEventListener('click', openCookiePreferences);
  document.addEventListener('shopify:section:load', (event) => revealElements(event.target));
})();
